import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useUser } from '@/contexts/UserContext';

interface DashboardRouterProps {
  userId: string;
}

export default function DashboardRouter({ userId }: DashboardRouterProps) {
  const [, setLocation] = useLocation();
  const { user, isLoggedIn, isLoading } = useUser();

  useEffect(() => {
    // Se ainda está carregando, aguarda
    if (isLoading) return;

    // Se não está logado, redireciona para login
    if (!isLoggedIn) {
      setLocation('/login');
      return;
    }

    // Se o usuário não existe ou o ID não confere, redireciona para home
    if (!user || !user.id || user.id !== userId) {
      setLocation('/');
      return;
    }

    // Redireciona baseado no tipo de usuário
    switch (user.role) {
      case 'photographer':
        setLocation('/photographer-dashboard');
        break;
      case 'athlete':
        setLocation('/athlete-dashboard');
        break;
      case 'admin':
        // Admin tem seu próprio dashboard
        setLocation('/admin-dashboard');
        break;
      default:
        // Tipo de usuário desconhecido, redireciona para home
        setLocation('/');
        break;
    }
  }, [userId, user, isLoggedIn, isLoading, setLocation]);

  // Mostra loading enquanto processa o redirecionamento
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Não renderiza nada após o redirecionamento
  return null;
}